import { createContext, HTMLProps } from 'react';

export interface AccordionItemContextState {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  disabled: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const AccordionItemContext = createContext<AccordionItemContextState>(undefined!);

export interface AccordionItemProps extends HTMLProps<HTMLDivElement> {
  isOpen?: boolean;
  setIsOpen?: (isOpen: boolean) => void;
  disabled?: boolean;
  defaultOpen?: boolean;
}
